import { render, staticRenderFns } from "./user-search.component.vue?vue&type=template&id=2cb542cf"
import script from "./user-search.component.vue?vue&type=script&lang=ts"
export * from "./user-search.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports